export const ACTIVITY_TRACKING_SLICE_NAME = 'activityTracking';

export interface ActivityTrackingSliceState {
  attempts: Attempt[];
  correctAttempts: number;
  incorrectAttempts: number;
}

export interface Attempt {
  isCorrect: boolean;
  description: string;
}
